import { render, staticRenderFns } from "./NewCategories.vue?vue&type=template&id=944f69de&scoped=true&"
import script from "./NewCategories.vue?vue&type=script&lang=js&"
export * from "./NewCategories.vue?vue&type=script&lang=js&"
import style0 from "./NewCategories.vue?vue&type=style&index=0&id=944f69de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f69de",
  null
  
)

export default component.exports